"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* An image's own shape (width / height), held within a range: the crop box
 * of a wide logo keeps the logo's shape (D-30), but never goes past what the
 * server accepts. */
 const aspectWithin = (width, height, [min, max]) =>
  width > 0 && height > 0 ? Math.min(max, Math.max(min, width / height)) : min; exports.aspectWithin = aspectWithin
